import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M22 4a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12Zm-4.738 9.33a2.535 2.535 0 0 0-2.5 0 2.453 2.453 0 0 0-1.25 2.13v.504a3.38 3.38 0 0 0 1.071 2.387c-.246.038-.715.14-.715.14-1.693.394-2.856 1.237-2.856 2.218v3.588c0 .388.32.703.714.703h8.57a.71.71 0 0 0 .716-.703v-3.588c0-.98-1.165-1.824-2.858-2.218l-.715-.14a3.405 3.405 0 0 0 1.073-2.387v-.503c0-.879-.477-1.691-1.25-2.13ZM15 7a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z" clip-rule="evenodd" stroke="none"></path>';
export var IdBadgeSVG = function IdBadgeSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
IdBadgeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(IdBadgeSVG);